import { render, staticRenderFns } from "./FirstTimeLoginBrand.vue?vue&type=template&id=3f66ce38&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f66ce38')) {
      api.createRecord('3f66ce38', component.options)
    } else {
      api.reload('3f66ce38', component.options)
    }
    module.hot.accept("./FirstTimeLoginBrand.vue?vue&type=template&id=3f66ce38&", function () {
      api.rerender('3f66ce38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/container/FirstTimeLoginBrand.vue"
export default component.exports